// ─── Storage Guide ────────────────────────────────────────────────────────────

const STORAGE_GUIDE: Record<string, {
  fridge:  string
  freezer: string
  pantry:  string
  tip:     string
  maxDays: { fridge: number; freezer: number; pantry: number }
}> = {
  fresh_produce: {
    fridge:  'Most produce lasts 3-7 days in the fridge',
    freezer: 'Blanch vegetables before freezing for up to 12 months',
    pantry:  'Root vegetables last 2-4 weeks at room temperature',
    tip:     'Store fruits and vegetables separately — fruits release ethylene gas that spoils vegetables faster',
    maxDays: { fridge: 7, freezer: 365, pantry: 14 },
  },
  dairy: {
    fridge:  'Keep at 35-38°F. Check the use-by date',
    freezer: 'Hard cheese freezes well. Milk changes texture when frozen',
    pantry:  'Not recommended — keep refrigerated at all times',
    tip:     'Store dairy on middle or lower shelves, not in the door where temperature fluctuates',
    maxDays: { fridge: 14, freezer: 90, pantry: 0 },
  },
  meat_fish: {
    fridge:  'Raw meat 1-2 days. Cooked meat 3-4 days',
    freezer: 'Freeze raw meat for up to 12 months',
    pantry:  'Never store raw meat at room temperature',
    tip:     'Store raw meat on the bottom shelf to prevent drips contaminating other food',
    maxDays: { fridge: 2, freezer: 365, pantry: 0 },
  },
  bread_bakery: {
    fridge:  'Fridge dries bread out — avoid if possible',
    freezer: 'Slice before freezing. Lasts 3 months',
    pantry:  'Room temperature in a bread box 3-5 days',
    tip:     'Freeze bread you won\'t use within 3 days — it toasts perfectly from frozen',
    maxDays: { fridge: 7, freezer: 90, pantry: 5 },
  },
  pantry_staple: {
    fridge:  'Not needed for most pantry staples',
    freezer: 'Flour and nuts last longer frozen',
    pantry:  'Cool dark place. Most last 6-24 months',
    tip:     'Store in airtight containers to prevent moisture and pests',
    maxDays: { fridge: 0, freezer: 365, pantry: 365 },
  },
  frozen: {
    fridge:  'Thaw in fridge overnight — never on counter',
    freezer: 'Keep at 0°F or below for best quality',
    pantry:  'Never store frozen items at room temperature',
    tip:     'Label frozen items with the date. Most frozen food is best within 3-6 months',
    maxDays: { fridge: 1, freezer: 180, pantry: 0 },
  },
  cleaning: {
    fridge:  'Not applicable',
    freezer: 'Not applicable',
    pantry:  'Cool dry place away from food. Check expiry date',
    tip:     'Store cleaning products away from food and out of reach of children',
    maxDays: { fridge: 0, freezer: 0, pantry: 730 },
  },
  personal_care: {
    fridge:  'Some skincare products last longer refrigerated',
    freezer: 'Not recommended',
    pantry:  'Cool dry place away from direct sunlight',
    tip:     'Check the PAO symbol (open jar icon) for how long to keep after opening',
    maxDays: { fridge: 0, freezer: 0, pantry: 365 },
  },
}

export function getStorageGuide(freshnessCategory: string, currentLocation: string) {
  const guide = STORAGE_GUIDE[freshnessCategory] ?? STORAGE_GUIDE.pantry_staple

  const loc = currentLocation === 'fridge'
    ? 'fridge'
    : currentLocation === 'freezer'
    ? 'freezer'
    : 'pantry'

  return {
    currentLocationTip:          guide[loc],
    tip:                         guide.tip,
    maxDaysInCurrentLocation:    guide.maxDays[loc],
    allLocations: {
      fridge:  guide.fridge,
      freezer: guide.freezer,
      pantry:  guide.pantry,
    },
  }
}
